import { useNavigate } from 'react-router';
import { toast } from 'sonner';

import { TwoFAForm, ITwoFAForm } from 'src/components/Authentication';
import { useAuth } from 'src/context/auth/use-auth';

const TwoFAContainer = () => {
  const { confirmTOTPCode } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async ({ code }: ITwoFAForm) => {
    try {
      await confirmTOTPCode(code);
      navigate('/');
    } catch (e: unknown) {
      if (e instanceof Error && e.name === 'SignInException') {
        toast.error(e.message);
        navigate('/login');
        return;
      }
      throw e;
    }
  };

  return <TwoFAForm onSubmit={onSubmit} />;
};

export default TwoFAContainer;
